// Hidden 2026-07-09 with the Pre-designed Templates payload below (unused while commented):
// import { DISCOVERY_TEMPLATES } from './discoveryTemplates';

// Hardcoded (non-AI) Tool selections streamed to the customizer in discovery mode.
//
// Mirrors discoveryAiTools.ts: selecting a Tool in the discovery panel streams a small marker that the
// customizer reads to enable that tool's sandbox experience. Get a Quote always runs a fully hardcoded
// sandbox in discovery mode — clicking the button opens a fixed 3-field form (Name, Last name, Email) and
// "submitting" just shows the success popup, with no backend call — see the customizer's useDiscoveryGetQuote.
//
// Add entries keyed by the DiscoveryModePanel item id.

// Hardcoded shape/mask catalog streamed with the Shapes and Masks tool. These are FULL shape records in the
// customizer's REST `shapes` shape (shapeID / shapeGuid / pathDataUrl / imageUrl / maskImageUrl / useAsMask /
// ...), NOT the trimmed backoffice GraphQL shape — the customizer needs pathDataUrl (the SVG path) and
// maskImageUrl to render a shape on canvas and to clip an image into a mask. It injects this catalog into its
// shape data layer (see useDiscoveryModeUpdater → dataFetcher), so the Shapes and Masks menus populate and
// render even on a sandbox product with no shapes configured. `useAsMask: true` records also appear in the
// Masks menu. Add 5–10 entries here.
const DISCOVERY_SHAPES_AND_MASKS: object[] = [
    {
        shapeID: 2000660,
        shapeGuid: '5e97a67f-6cdd-406b-aaa6-d82759cc76a8',
        name: 'Arrow up',
        tags: 'arrow up',
        pathDataUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/2ef6296a8757481ea222383feb2a6066/pathdata.txt',
        imageUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/5e1600bfb8e1423eb46a0a0bab4a7e05/shape.png',
        maskImageUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/bb2313be78df4ab7bc7d65a7ad9dd68b/mask.png',
        useAsMask: true,
        isDefault: false,
        position: null
    },
    {
        shapeID: 2000664,
        shapeGuid: '46c85937-b46d-4769-9013-b1b27d5d416f',
        name: 'Baloon 1',
        tags: 'baloon',
        pathDataUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/9b051cbaf0bd4533b18c6e7a4a691f9f/pathdata.txt',
        imageUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/c43799fa64df4eec9071e4eece0d9c2a/shape.png',
        maskImageUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/e7032c0ba08c4719bb31184a65437819/mask.png',
        useAsMask: true,
        isDefault: false,
        position: null
    },
    {
        shapeID: 2000665,
        shapeGuid: '9557f396-4654-442b-9214-2517fed52416',
        name: 'Baseball',
        tags: 'sport',
        pathDataUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/d15ebf535f7744c1947ff130a19cc498/pathdata.txt',
        imageUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/90325ef084414671aa7849b4435a1fd6/shape.png',
        maskImageUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/245b1bca3415412b8235b3c4579c6697/mask.png',
        useAsMask: true,
        isDefault: false,
        position: null
    },
    {
        shapeID: 2000702,
        shapeGuid: 'f91fe0a3-fc7f-4226-b68a-65d4c5fcb0c6',
        name: 'Heart 2',
        tags: 'heart | basic',
        pathDataUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/e9d02e62120344d48410e522d83f3f10/pathdata.txt',
        imageUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/f2a05044acfa468eb2c4058f2e6b311d/shape.png',
        maskImageUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/cdd3cd70fce642e98b01db76c7ebcdab/mask.png',
        useAsMask: true,
        isDefault: false,
        position: null
    },
    {
        shapeID: 2000714,
        shapeGuid: '4a138db7-6b52-441d-8688-4729aefda82b',
        name: 'Nonagon',
        tags: 'geomtetric | polygon',
        pathDataUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/f56acdd373c84249a6774134ae786859/pathdata.txt',
        imageUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/cacbbc0c15984db38e8839c4b350715f/shape.png',
        maskImageUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/27c5c8293d7e4f6cb124b179232efb7e/mask.png',
        useAsMask: true,
        isDefault: false,
        position: null
    },
    {
        shapeID: 2000713,
        shapeGuid: 'a9ffce63-dfc4-444b-9681-06c57fa820ec',
        name: 'Mustache 2',
        tags: 'funny faces | mustache',
        pathDataUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/0a0c89c90e15481f8c09ff22e9efb4f2/pathdata.txt',
        imageUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/28abc8b3ddc84888a0cd52c9841164e0/shape.png',
        maskImageUrl: 'https://cdn-testing.zakeke.com/files/images/sourcefiles/2025/06/18/e34f825313ce4178ab01cc51cfdbecde/mask.png',
        useAsMask: true,
        isDefault: false,
        position: null
    }
];

// Hardcoded Fill Background rule streamed with the Fill Background tool. The customizer surfaces this as the
// product-level background rule (see useZakekeBackgroundEditRules), lighting up the Fill Background tool with:
//  - a solid-color tab left as an UNLIMITED palette (`colorList: []` — empty, NOT null: an empty list keeps the
//    color tab visible, whereas null would hide it). An empty list reads as "no restriction", so the customizer
//    renders its standard full color picker (AllColorsPicker) alongside the default swatches (`defaultQuickColors`
//    in the UI's backgroundEditColorTab.tsx) — the same experience as a real digital product, and
//  - the Upload tab (`enableImageCustomerGallery: true`, `imageTypeID: 1` → jpg/png) to set an uploaded image
//    as the background, and
//  - the seller Gallery tab (`enableImageSellerGallery: true`) — loads the seller's REAL background gallery
//    (their personalized set, or the Zakeke default that accounts import at signup), fetched live by the
//    customizer from the account's ImageService (NOT streamed here). Legacy accounts with no gallery imported
//    yet see it empty until they import the default from the backoffice discovery panel.
//    Works even on a product with no background rules configured.
const DISCOVERY_FILL_BACKGROUND_RULE = {
    colorList: [],
    imageTypeID: 1,
    enableImageCustomerGallery: true,
    enableImageSellerGallery: true,
    enableNoColor: true
};

export const DISCOVERY_TOOLS_PAYLOADS: Record<string, object> = {
    'get-a-quote': { tool: 'get-a-quote' },
    'shapes-and-masks': { tool: 'shapes-and-masks', shapes: DISCOVERY_SHAPES_AND_MASKS },
    'fill-background': { tool: 'fill-background', backgroundRule: DISCOVERY_FILL_BACKGROUND_RULE },
    // Collage Layouts streams the REAL system grid catalog, fetched via DiscoveryCollagePrefetch and injected at
    // click time (see testPage handleDiscoverySelect). This bare marker is the fallback if the prefetch hasn't
    // resolved yet — the tool activates with no layouts rather than a stale hardcoded set.
    'collage-layouts': { tool: 'collage-layouts' },
    // Hidden 2026-07-09: Pre-designed Templates payload — see DiscoveryModePanel. A resolved template is locked to
    // its model and its images belong to the authoring account, so fetchImage 404s on an arbitrary discovery
    // product. Re-enable (with the DiscoveryModePanel pill) once the specialized admin-account design API exists.
    // 'pre-designed-templates': { tool: 'pre-designed-templates', templates: DISCOVERY_TEMPLATES }
    // AI Vectorizer and AI Background Remover used to live here as tools. They are now discovery PRINT
    // METHODS (see discoveryPrintMethods.ts): both are print-type settings, so streaming a print type that
    // carries them demos each one through the customizer's real code path instead of a forced tool marker.
};
